import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

export type GetShipmentInvoicesFactoryDependencies = {
  repository: ShipmentRepository
}

export function getShipmentInvoicesFactory({ repository }: GetShipmentInvoicesFactoryDependencies) {
  return async function getInvoices(uuid: string, config?: { signal?: AbortSignal }) {
    try {
      return await repository.getInvoices(uuid, config)
    } catch (error) {
      throw new Error('Failed to get the Shipment invoices', { cause: error as Error })
    }
  }
}

export function getShipmentInvoices(id: string, config?: { signal?: AbortSignal }) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const get = getShipmentInvoicesFactory({ repository })

  return get(id, config)
}
